<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-file fa-fw" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="tile-title">{{review.course_title}}</div>
            <div class="tile-title">{{review.component_title}}</div>
        </template>
        <template v-slot:details>
            <div class="mt-3">
                <toolbar class="toolbar">
                    <button class="icon-only" @click.stop=""><i class="far fa-pencil"></i></button>
                </toolbar>

                <div class="data mt-1">
                    <data-row mini title="ID">{{review.id}}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";

    export default {
        name: 'ReviewTile',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            review: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                details: false,
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }
</style>
